import React, { useState, useEffect } from 'react';
import Header from './Header'; // Import Header component
import Sidebar from './Sidebar'; // Import Sidebar component
import './DoctorHistory.css'; // Ensure you create this CSS file for styling
import './Dashboard.css'; // Ensure you create this CSS file for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {axiosInstance} from './helper/axiosConfig';
import { Link, useLocation } from 'react-router-dom'; // Import Link and useLocation for navigation
import { faArrowLeft, faChevronLeft, faChevronRight, faCamera, faPrint, faShareAlt, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'; // Import icons


function Report() {
  const [doctorHistory, setDoctorHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-main">
        <Header />
        <div className="content-box">
          <div className="doctor-history-container">
            <div className="header-container">
              <h1>Report’s</h1>
            </div>
          </div>
        </div>
        <div className="footer-content">
            {process.env.REACT_APP_COPYRIGHT_TEXT || "© 2025, Powered by AmarLab"}
        </div>
      </div>
    </div>
  );
}

export default Report;
